module.exports = __webpack_public_path__ + "static/media/architecture.df8597e2.png";